import jsPDF from "jspdf";
import "jspdf-autotable";
import * as table from "./TableData";
import Image from "../../../../assets/images/CBM_BlackWhite.png";
import { amountCommaSeparateFunc } from "../../../../components/Common/CommonFunction";

const PosInvoiceReport = (data) => {
    const transformedItems = [];
    const mixGroups = {};

    data.InvoiceItems.forEach((item) => {
        if (item.MixItemId) {
            if (!mixGroups[item.MixItemId]) {
                mixGroups[item.MixItemId] = [];
            }
            mixGroups[item.MixItemId].push(item);
        }
    });

    data.InvoiceItems.forEach((item) => {
        if (item.MixItemId === null) {
            transformedItems.push({
                ...item,
                MixItems: mixGroups[item.Item] || [],
            });
        } else if (!data.InvoiceItems.find((p) => p.Item === item.MixItemId)) {
            transformedItems.push(item);
        }
    });

    const widthInInches = 3.14;
    const widthInPoints = widthInInches * 72;
    const lineHeight = 50;
    const marginTop = 40;
    const marginBottom = 40;

    const length = data.InvoiceItems.length;
    const totalContentHeight = length * lineHeight + 500;

    var doc = new jsPDF({
        orientation: "p",
        unit: "pt",
        format: [widthInPoints, totalContentHeight],
    });

    doc.addImage(Image, "png", 50, 10, 130, 80, null, "FAST");

    const dottedLineY = marginTop + 54;
    const lineWidth = widthInPoints - 20;
    doc.setLineDash([1, 1]);
    doc.line(10, dottedLineY, 10 + lineWidth, dottedLineY);
    doc.setLineDash([]);
    doc.setFont("Cambria", "normal");

    let isCoustomeGSTIN = !(data.CustomerGSTIN === "");
    var DetailsStyle = {
        didParseCell: (data1) => {
            data1.table.body[0].cells[0].styles.fontSize = 15;
            data1.table.body[0].cells[0].styles.fontStyle = "bold";
            data1.table.body[0].cells[0].styles.halign = "center";

            data1.table.body[1].cells[0].styles.fontSize = 11;
            data1.table.body[1].cells[0].styles.fontStyle = "bold";
            data1.table.body[1].cells[0].styles.halign = "center";

            data1.table.body[2].cells[0].styles.halign = "center";
            data1.table.body[2].cells[0].styles.fontSize = 10;

            data1.table.body[3].cells[0].styles.halign = "center";
            data1.table.body[3].cells[0].styles.fontSize = 9;

            data1.table.body[4].cells[0].styles.fontStyle = "bold";
            data1.table.body[4].cells[0].styles.halign = "center";
            data1.table.body[4].cells[0].styles.fontSize = 9;

            if (isCoustomeGSTIN) {
                data1.table.body[5].cells[0].styles.fontSize = 7;
                data1.table.body[5].cells[0].styles.fontStyle = "bold";
            }
        },
        margin: { top: 45, left: 10, right: 35 },
        showHead: "always",
        theme: "plain",
        styles: { overflow: "linebreak", font: "Cambria", fontSize: 9, height: 0 },
        bodyStyles: {
            columnWidth: "wrap",
            textColor: [30, 30, 30],
            cellPadding: 1,
            fontSize: 9,
            fontStyle: "normal",
            lineColor: [0, 0, 0],
        },
        columnStyles: { 0: { valign: "top", columnWidth: 210, halign: "left" } },
        tableLineColor: "black",
        startY: 100,
    };

    doc.autoTable(table.Details, table.DetailsRow(data), DetailsStyle);

    let rowMeta = [];
    transformedItems.forEach((item) => {
        rowMeta.push("parent");
        if (item.MixItems && item.MixItems.length > 0) {
            item.MixItems.forEach(() => rowMeta.push("child"));
        }
    });

    var ItemStyle = {
        margin: { top: 45, left: 10, right: 35 },
        didParseCell: (hookData) => {
            const { row, cell } = hookData;
            if (row.raw.length === 1) {
                cell.colSpan = 3;
                cell.styles.fontSize = 9;
                cell.styles.halign = "left";
            }
        },
        didDrawCell: (Table_data) => {
            const { cell, row } = Table_data;
            doc.setDrawColor(0, 0, 0);
            if (row.index === 0 || Table_data.section === "head") {
                doc.setLineWidth(cell.styles.lineWidth);
                doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
            }
            const currentType = rowMeta[row.index];
            const nextRow = Table_data.table.body[row.index + 1];
            const nextType = nextRow ? rowMeta[row.index + 1] : null;
            if (currentType === "parent" && nextType !== "child") {
                doc.line(
                    cell.x,
                    cell.y + cell.height,
                    cell.x + cell.width,
                    cell.y + cell.height
                );
            }
            if (currentType === "child" && (nextType === "parent" || !nextRow)) {
                doc.line(
                    cell.x,
                    cell.y + cell.height,
                    cell.x + cell.width,
                    cell.y + cell.height
                );
            }
            if (!nextRow) {
                doc.line(
                    cell.x,
                    cell.y + cell.height,
                    cell.x + cell.width,
                    cell.y + cell.height
                );
            }
            return false;
        },
        theme: "plain",
        styles: {
            overflow: "linebreak",
            fontSize: 8,
            font: "Cambria",
            lineHeight: 1,
        },
        bodyStyles: {
            columnWidth: "wrap",
            textColor: [30, 30, 30],
            cellPadding: 2,
            fontSize: 9,
            fontStyle: "normal",
        },
        headerStyles: {
            cellPadding: 3,
            valign: "top",
            fontStyle: "bold",
            halign: "center",
            fillColor: "white",
            textColor: [0, 0, 0],
            fontSize: 9,
        },
        columnStyles: {
            0: { valign: "top", columnWidth: 50, halign: "left" },
            1: { valign: "top", columnWidth: 110, halign: "center" },
            2: { valign: "top", columnWidth: 50, halign: "right" },
        },
        tableLineColor: "black",
        startY: doc.previousAutoTable.finalY,
    };
    const itemCount = data.InvoiceItems.length;
    doc.autoTable(table.Item(itemCount), table.ItemRow(transformedItems), ItemStyle);

    doc.setFontSize(9);
    doc.text(
        `------------ GST Break Up details ------------`,
        113,
        doc.previousAutoTable.finalY + 13,
        "center"
    );

    var GSTDetailsStyle = {
        margin: { top: 45, left: 10, right: 35 },
        theme: "grid",
        styles: { overflow: "linebreak", fontSize: 9, font: "Cambria", height: 0 },
        bodyStyles: {
            columnWidth: "wrap",
            textColor: [30, 30, 30],
            cellPadding: 2,
            fontSize: 9,
            fontStyle: "normal",
            lineColor: [0, 0, 0],
        },
        headerStyles: {
            cellPadding: 3,
            lineWidth: 0.8,
            valign: "top",
            fontStyle: "bold",
            halign: "center",
            fillColor: "white",
            textColor: [0, 0, 0],
            fontSize: 8,
            rowHeight: 10,
            lineColor: "black",
        },
        columnStyles: {
            0: { valign: "top", columnWidth: 70, halign: "center" },
            1: { valign: "top", columnWidth: 70, halign: "center" },
            2: { valign: "top", columnWidth: 70, halign: "center" },
        },
        tableLineColor: "black",
        startY: doc.previousAutoTable.finalY + 20,
    };
    doc.autoTable(
        table.GSTDetails,
        table.GSTDetailsRow(data, doc),
        GSTDetailsStyle
    );

    // ----------------- Offer Applied Section (except 1 & 11) -----------------
    let GST_Table_Y = doc.previousAutoTable.finalY;
    const pageWidth = doc.internal.pageSize.getWidth();

    const offerSchemes = data.AppliedSchemes?.filter(
        (s) => s.SchemeType !== 1 && s.SchemeType !== 11
    );

    if (offerSchemes && offerSchemes.length > 0) {
        const schemeNames = offerSchemes.map((s) => s.SchemeName).join(", ");
        const text = `Offer applied: ${schemeNames}`;

        doc.setFont("Helvetica", "normal");
        doc.setFontSize(8);

        const maxTextWidth = pageWidth - 15;
        const splitText = doc.splitTextToSize(text, maxTextWidth);

        const verticalPadding = 10;
        const xPos = 10;
        const yPos = GST_Table_Y + verticalPadding;

        doc.text(splitText, xPos, yPos);

        // ✅ Dynamically calculate block height
        const textDimensions = doc.getTextDimensions(splitText);
        const blockHeight = textDimensions.h + verticalPadding;

        // Push Y down properly after the entire offer text block
        GST_Table_Y += blockHeight;
    }

    // ----------------- Totals -----------------
    let totalAmount = 0;
    let totalDiscount = 0;
    data.InvoiceItems.forEach((arg) => {
        totalAmount += Number(arg.Amount);
        totalDiscount += Number(arg.DiscountAmount);
    });

    doc.setFontSize(8);
    let lineY = GST_Table_Y + 5;

    if (totalDiscount !== 0) {
        // Total + Discount
        doc.text(`Total Amount:`, 10, lineY);
        doc.text(
            `${(totalAmount + totalDiscount).toFixed(2)}`,
            pageWidth - 20,
            lineY,
            { align: "right" }
        );

        doc.text(`Discount Amount:`, 10, lineY + 12);
        doc.text(
            `${Number(totalDiscount).toFixed(2)}`,
            pageWidth - 20,
            lineY + 12,
            { align: "right" }
        );

        // First horizontal line BELOW discount amount
        doc.line(10, lineY + 18, pageWidth - 10, lineY + 18);
        lineY += 18;
    }

    // Grand Total (inside the two lines)
    doc.setFontSize(9);
    doc.setFont("Helvetica", "bold");

    if (Number(data.AdvanceAmount) > 0) {
        doc.text(`Advance Amount:`, 10, lineY + 10);
        doc.text(
            `${amountCommaSeparateFunc(Number(data.AdvanceAmount).toFixed(2))}`,
            pageWidth - 20,
            lineY + 10,
            { align: "right" }
        );

        doc.text(`Total:`, 10, lineY + 22);
        doc.text(
            `${amountCommaSeparateFunc(Number(data.GrandTotal).toFixed(2))}`,
            pageWidth - 20,
            lineY + 22,
            { align: "right" }
        );

        // Second horizontal line BELOW grand total
        doc.line(10, lineY + 28, pageWidth - 10, lineY + 28);
        GST_Table_Y = lineY + 28;
    } else {
        doc.text(`Total:`, 10, lineY + 10);
        doc.text(
            `${amountCommaSeparateFunc(Number(data.GrandTotal).toFixed(2))}`,
            pageWidth - 20,
            lineY + 10,
            { align: "right" }
        );

        // Second horizontal line BELOW grand total
        doc.line(10, lineY + 16, pageWidth - 10, lineY + 16);
        GST_Table_Y = lineY + 16;
    }

    // ----------------- Other Schemes (SchemeType 1 & 11) -----------------
    const otherSchemes = data.AppliedSchemes?.filter(
        (s) => s.SchemeType === 1 || s.SchemeType === 11
    );
    let totalSchemeValue = 0;

    if (otherSchemes && otherSchemes.length > 0) {
        let currentY = GST_Table_Y + 16; // starting position
        const normalLineHeight = 6; // for single-line scheme
        const wrappedLineHeight = 10; // for multi-line schemes
        const schemePadding = 5; // space between schemes
        const lastSchemeExtraPadding = 8; // extra gap before Total Payable

        otherSchemes.forEach((scheme, idx) => {
            totalSchemeValue += scheme.SchemeValue;

            doc.setFontSize(9);
            doc.setFont("Helvetica", "normal");

            // Wrap scheme name to fit page width (leave space for amount)
            const maxTextWidth = pageWidth - 60;
            let cleanSchemeName = scheme.SchemeName.replace(/\\u20b9/g, "Rs. ") // replace Unicode version
                .replace(/₹/g, "Rs. ") // replace actual rupee symbol if present
                .replace(/\s+/g, " ") // remove extra spaces
                .trim();

            // Wrap cleaned text properly
            const wrappedText = doc.splitTextToSize(cleanSchemeName, maxTextWidth);

            // Choose line height based on whether text wraps
            const lineHeight =
                wrappedText.length > 1 ? wrappedLineHeight : normalLineHeight;

            // Print scheme name
            wrappedText.forEach((line, i) => {
                doc.text(line, 10, currentY + i * lineHeight);
            });

            // Print scheme value on the first line (right-aligned)
            doc.text(`${scheme.SchemeValue.toFixed(2)}`, pageWidth - 20, currentY, {
                align: "right",
            });

            // Move Y down for next scheme
            if (idx === otherSchemes.length - 1) {
                // extra padding after last scheme
                currentY += wrappedText.length * lineHeight + lastSchemeExtraPadding;
            } else {
                currentY += wrappedText.length * lineHeight + schemePadding;
            }
        });

        // ----------------- Total Payable -----------------
        const totalPayable = data.GrandTotal - totalSchemeValue;

        doc.setFontSize(11);
        doc.setFont("Helvetica", "bold");
        doc.text("Total Payable:", 10, currentY);
        doc.text(`${totalPayable.toFixed(2)}`, pageWidth - 20, currentY, {
            align: "right",
        });

        // Horizontal line below Total Payable
        doc.line(10, currentY + 5, pageWidth - 10, currentY + 5);

        // Update GST_Table_Y for the next section
        GST_Table_Y = currentY + 5;
    }

    var DiscriptionStyle = {
        didParseCell: (data1) => {
            data1.table.body[1].cells[0].styles.fontSize = 9;
            data1.table.body[1].cells[0].styles.fontStyle = "bold";
            data1.table.body[1].cells[0].styles.halign = "center";
        },
        margin: { top: 45, left: 10, right: 35 },
        showHead: "always",
        theme: "plain",
        styles: { overflow: "linebreak", fontSize: 8, font: "Cambria", height: 0 },
        bodyStyles: {
            columnWidth: "wrap",
            textColor: [30, 30, 30],
            cellPadding: 1,
            fontSize: 8,
            fontStyle: "normal",
            lineColor: [0, 0, 0],
        },
        columnStyles: { 0: { valign: "top", columnWidth: 210, halign: "center" } },
        tableLineColor: "black",
        startY: GST_Table_Y + 4,
    };

    doc.autoTable(
        table.Discription,
        table.DiscriptionRow(data),
        DiscriptionStyle
    );
    doc.setLineDash([1, 1]);
    const Discription_Table_Y = doc.previousAutoTable.finalY;
    doc.line(
        10,
        Discription_Table_Y + 5,
        10 + lineWidth,
        Discription_Table_Y + 5
    );
    doc.setFontSize(10);
    doc.text(`Cashier: ${data.CashierName}`, 10, Discription_Table_Y + 20);
    doc.setFontSize(12);
    doc.text(`Thank You...!`, 113, Discription_Table_Y + 35, "center");

    doc.setProperties({
        title: `InvoiceReport/${data.InvoiceDate}-${data.CustomerName} `,
    });

    function generateSaveAndOpenPDFReport() {
        const pdfUrl = URL.createObjectURL(doc.output("blob"));
        window.open(pdfUrl);
    }
    generateSaveAndOpenPDFReport();
};

export default PosInvoiceReport;
